import { render, staticRenderFns } from "./DefaultFooter.vue?vue&type=template&id=d7098314&scoped=true"
import script from "./DefaultFooter.vue?vue&type=script&lang=js"
export * from "./DefaultFooter.vue?vue&type=script&lang=js"
import style0 from "./DefaultFooter.vue?vue&type=style&index=0&id=d7098314&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7098314",
  null
  
)

export default component.exports